import { BrowserRouter, Routes, Route } from 'react-router-dom';


import React from 'react'
import Home from "./pages/home/Home";
import About from "./pages/about/About";
import Contact from "./pages/contact/Contact";
import Gallery from "./pages/gallery/Gallery";
import Plans from "./pages/plans/Plans";
import Trainers from "./pages/trainers/Trainers";
import Notfound from "./pages/notfpund/Notfound";


import Navbar from './component/navbar/Navbar';
import Footer from './component/footer/Footer';

function App() {
  return (
    <BrowserRouter>
      <Navbar />
      <Routes>
        
        <Route index element={<Home/>}/>
        <Route path='about' element={<About/>}/>
        <Route path='contact' element={<Contact/>}/>
        <Route path='Gallery' element={<Gallery/>}/>
        <Route path='Plans' element={<Plans />}/>
        <Route path='trainers' element={<Trainers/>}/>
        <Route path='*' element={<Notfound/>}/>


      </Routes>
      <Footer />
    </BrowserRouter>
  )
}

export default App